export default __webpack_public_path__ + "static/media/appointment-icon.8a99d7f3.png";